export const RULE_MASTER_QUERY_INPUT_CHANGE = 'RULE_MASTER_QUERY_INPUT_CHANGE';

export const START_LOAD_RULE_MASTER = 'START_LOAD_RULE_MASTER';
export const LOAD_RULE_MASTER_SUCCESS = 'LOAD_RULE_MASTER_SUCCESS';
export const LOAD_RULE_MASTER_FAILURE = 'LOAD_RULE_MASTER_FAILURE';
export const INIT_LOAD_RULE_MASTER_ACTION_STATUS = 'INIT_LOAD_RULE_MASTER_ACTION_STATUS';

export const SELECT_RULE_MASTER = 'SELECT_RULE_MASTER';

export const OPEN_ADD_OR_EDIT_RULE_MASTER_MODAL = 'OPEN_ADD_OR_EDIT_RULE_MASTER_MODAL';
export const ADD_OR_EDIT_RULE_MASTER_CHANGE_INPUT = 'ADD_OR_EDIT_RULE_MASTER_CHANGE_INPUT';
export const RESET_ADD_OR_EDIT_RULE_MASTER_MODAL = 'RESET_ADD_OR_EDIT_RULE_MASTER_MODAL';
export const START_SAVE_RULE_MASTER = 'START_SAVE_RULE_MASTER';
export const SAVE_RULE_MASTER_SUCCESS = 'SAVE_RULE_MASTER_SUCCESS';
export const SAVE_RULE_MASTER_FAILURE = 'SAVE_RULE_MASTER_FAILURE';
export const INIT_SAVE_RULE_MASTER_ACTION_STATUS = 'INIT_SAVE_RULE_MASTER_ACTION_STATUS';

export const START_DELETE_RULE_MASTER = 'START_DELETE_RULE_MASTER';
export const DELETE_RULE_MASTER_SUCCESS = 'DELETE_RULE_MASTER_SUCCESS';
export const DELETE_RULE_MASTER_FAILURE = 'DELETE_RULE_MASTER_FAILURE';
export const INIT_DELETE_RULE_MASTER_ACTION_STATUS = 'INIT_DELETE_RULE_MASTER_ACTION_STATUS';

export const ADD_RULE_MASTER_GRID_TO_PROPS = 'ADD_RULE_MASTER_GRID_TO_PROPS';
